'use strict';

var dom        = require('spa-dom'),
    Scrollbar  = require('stb-component-scrollbar'),
    ScrollArea = require('mag-component-scroll-area'),

    infoPanel = {},

    tag = dom.tag,

    $infoContainer, $holderContainer,
    $poster, $genres, $director,
    $year, $country, $language,
    $backInformation;

infoPanel.init = function () {
    $infoContainer = tag(
        'div',
        {},
        $poster = tag('div', {className: 'info poster'}),
        tag('div', {className: 'info title theme-subhead-color'}, gettext('Singer:')),
        $director = tag('div', {className: 'info director'}),
        tag('div', {className: 'info title theme-subhead-color'}, gettext('Genres:')),
        $genres = tag('div', {className: 'info genres'}),
        tag('div', {className: 'info title theme-subhead-color'}, gettext('Year:')),
        $year = tag('div', {className: 'info year'}),
        tag('div', {className: 'info title theme-subhead-color'}, gettext('Language:')),
        $language = tag('div', {className: 'info language'}),
        tag('div', {className: 'info title theme-subhead-color'}, gettext('Country:')),
        $country = tag('div', {className: 'info country'})
    );

    $holderContainer = tag('div', {className: 'info placeholder'});

    this.textArea = new ScrollArea({
        propagate: true,
        step: 5,
        scroll: new Scrollbar({})
    });
    this.textArea.$body.appendChild($infoContainer);
    this.textArea.$body.appendChild($holderContainer);

    $backInformation = tag('div', {className: 'backDesk'}, gettext('Back to previous list'));
    this.textArea.$body.appendChild($backInformation);
};

infoPanel.clear = function () {
    $poster.style.backgroundImage = '';
    $infoContainer.style.display = 'none';
    this.textArea.init();
    $genres.innerText = '';
    $director.innerText = '';
    $year.innerText = '';
};

infoPanel.hideInfo = function () {
    $infoContainer.style.display = 'none';
    $holderContainer.style.display = 'block';
    this.textArea.init();
};

infoPanel.hideHolder = function () {
    $holderContainer.style.display = 'none';
};

infoPanel.showHolder = function () {
    $holderContainer.style.display = 'block';
};

infoPanel.showBackDesk = function () {
    $backInformation.style.display = 'block';
};

infoPanel.hideBackInformation = function () {
    $backInformation.style.display = 'none';
};

/**
 * Fill active track info.
 *
 * @param {Object} data - data to fill track info
 */
infoPanel.fillTracks = function ( data ) {
    var genresArr = [],
        index;

    if ( !data ) {
        $infoContainer.style.display = 'none';
        // $holderContainer.style.display = 'block';
        $backInformation.style.display = 'block';
        infoPanel.textArea.init();

        return;
    }
    $backInformation.style.display = 'none';
    $holderContainer.style.display = 'none';
    $infoContainer.style.display = 'block';
    for ( index = 0; index < data.album.genres.length; index++ ) {
        genresArr.push(data.album.genres[index].name);
    }
    if ( data.album.cover ) {
        $poster.style.backgroundImage = 'url(' + core.backend.host + data.album.cover + ')';
    } else {
        $poster.style.backgroundImage = '';
    }
    $genres.innerText = genresArr.join(', ');
    $director.innerText = data.album.artist.name;
    $year.innerText = data.album.year.name;
    $country.innerText = data.album.country.name;
    $language.innerText = data.language;
    infoPanel.textArea.init();
};

/**
 * Fill active artist info.
 *
 * @return {boolean} now allways false
 */
infoPanel.fillArtist = function () {

    return false;
};

/**
 * Fill active album info.
 *
 * @param {Object} data - data to fill album info
 */
infoPanel.fillAlbums = function ( data ) {
    var genresArr = [],
        index;

    if ( !data ) {
        $infoContainer.style.display = 'none';
        $backInformation.style.display = 'block';
        infoPanel.textArea.init();

        return;
    }

    $backInformation.style.display = 'none';
    $infoContainer.style.display = 'block';
    for ( index = 0; index < data.genres.length; index++ ) {
        genresArr.push(data.genres[index].name);
    }
    if ( data.cover ) {
        $poster.style.backgroundImage = 'url(' + core.backend.host + data.cover + ')';
    } else {
        $poster.style.backgroundImage = 'url(img/placeholder.png)';
    }
    $genres.innerText = genresArr.join(', ');
    $director.innerText = data.artist.name;
    $year.innerText = data.year.name;
    $country.innerText = data.country.name;
    $language.innerText = data.languages.join(', ');
    infoPanel.textArea.init();
};

/**
 * Fill active playlist info.
 *
 * @return {boolean} now allways false
 */
infoPanel.fillList = function () {

    return false;
};


module.exports = infoPanel;
